import { useContext } from "react";
import {
  BreadcrumbContext,
  type BreadcrumbContextValue,
} from "./breadcrumb-context";

export function useBreadcrumbContext(): BreadcrumbContextValue {
  const ctx = useContext(BreadcrumbContext);
  if (!ctx) {
    throw new Error("useBreadcrumbContext must be used within BreadcrumbProvider");
  }
  return ctx;
}
